<template>
  <div :class="className">
    <div class="inset__inner">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    columns: {
      type: String,
      default: '1'
    }
  },
  computed: {
    className() {
      return `inset inset--col-${this.columns}`
    }
  }
}
</script>


<style lang="postcss">
@screen md {
  .inset {
    @apply -mx-4;
  }
  .inset--col-1 .inset__inner {
    @apply w-10/12 px-4 mx-auto;
  }
  .inset--col-2 .inset__inner {
    @apply w-8/12 px-4 mx-auto;
  }
}
</style>
